import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../icon-button';
import HorizontalStack from '../horizontal-stack';
import { APPEARANCES, SIZES } from '../icon-button/constants';
import { iconsList } from '../icon/glyphs';
import { SPACING } from '../stack/constants';

const defaultActions = [];

function IconButtonGroup({ actions = defaultActions, gap = 'spacing-3-xs' }) {
  if (!actions.length) return null;

  return (
    <HorizontalStack gap={gap} verticalAlign="center">
      {actions.map((action) => {
        const {
          glyph,
          label,
          size,
          appearance,
          transparent,
          selected,
          disabled,
          onClick,
          onMouseDown,
        } = action;

        const handleClick = (e) => {
          e.stopPropagation();
          onClick();
        };

        return (
          <IconButton
            key={`icon-button-${label}-${glyph}`}
            glyph={glyph}
            label={label}
            size={size}
            appearance={appearance}
            transparent={transparent}
            selected={selected}
            disabled={disabled}
            onClick={handleClick}
            onMouseDown={onMouseDown}
          />
        );
      })}
    </HorizontalStack>
  );
}

IconButtonGroup.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      glyph: PropTypes.oneOf(iconsList),
      label: PropTypes.string,
      size: PropTypes.oneOf(Object.values(SIZES)),
      appearance: PropTypes.oneOf(Object.values(APPEARANCES)),
      transparent: PropTypes.bool,
      selected: PropTypes.bool,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
      onMouseDown: PropTypes.func,
    })
  ),
  gap: PropTypes.oneOf(SPACING),
};

export default IconButtonGroup;
